import { all_routes } from "../../../../feature-module/router/all_routes";

export const instructorSidebarData = [
    {
        title:'Dashboard',
        icon:'isax isax-grid-35',
        route: all_routes.instructorDashboard
    },
    {
        title:'Schedule Exam',
        icon:'isax isax-calendar',
        route: all_routes.scheduleExam
    },
    // {
    //     title:'My Profile',
    //     icon:'fa-solid fa-user',
    //     route: all_routes.instructorProfile
    // },
    // {
    //     title:'Category',
    //     icon:'isax isax-clipboard-text5',
    //     route: all_routes.instructorAssignment
    // },
    // {
    //     title:'Courses',
    //     icon:'isax isax-teacher5',
    //     route: all_routes.instructorCourse
    // },
   
   
    {
        title:'Students',
        icon:'isax isax-people me-2',
        route: all_routes.adminStudentsList
    },
 
    {
        title:'Quiz',
        icon:'isax isax-award5',
        route: all_routes.instructorQuiz,
    },
      {
        title:'Change Password',
        icon:'isax isax-lock-1',
        route: all_routes.changePassowrd,
    },
   
]